import { render, staticRenderFns } from "./NFTRenderer.vue?vue&type=template&id=0c9ece1d&scoped=true&"
import script from "./NFTRenderer.vue?vue&type=script&lang=ts&"
export * from "./NFTRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./NFTRenderer.vue?vue&type=style&index=0&id=0c9ece1d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9ece1d",
  null
  
)

export default component.exports